/* eslint-disable no-param-reassign */
const libertyCoins = require('./coins/liberty');
const equalityCoins = require('./coins/equality');
const fraternityCoins = require('./coins/fraternity');

// Merge all coins into a single array
const coins = [...libertyCoins, ...equalityCoins, ...fraternityCoins];

// Add metal property based on coin id
coins.forEach((coin) => {
  coin.metal = coin.id.startsWith('silver') ? 'silver' : 'gold';
});
module.exports = coins;
